export default __webpack_public_path__ + "static/media/displayXLg.04771bde.png";